import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { useCellSelectionDispatch, useCellSelectionSelector } from '../../redux/reduxHooks';
import { endDrag, getIsDragging } from '../redux/cellSelectionSlice';

/**
 * Ends an in-progress drag on the next mouseup anywhere in the document. A
 * document-level listener (rather than one on the table) is required so that
 * releasing the mouse outside the table still finishes the selection.
 */
export const useEndDragOnMouseUp = () => {
  const $ = _c(4);
  const dispatch = useCellSelectionDispatch();
  const isDragging = useCellSelectionSelector(getIsDragging);
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== isDragging) {
    t0 = () => {
      if (!isDragging) {
        return;
      }
      const handleMouseUp = () => dispatch(endDrag());
      document.addEventListener("mouseup", handleMouseUp);
      return () => document.removeEventListener("mouseup", handleMouseUp);
    };
    t1 = [dispatch, isDragging];
    $[0] = dispatch;
    $[1] = isDragging;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};